import actionTypes from './actionTypes'

const routeActions = {
	initializeMatchingPairsCreationTool(mpUID, params, search) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_INITIALIZE_ROUTE,
			mpUID,
			params,
			search,
		}
	},
	finalizeMatchingPairsCreationTool() {
		return {
			type: actionTypes.MATCHING_PAIRS_FINALIZE_ROUTE,
		}
	},
	initializeMatchingPairsScreenshot(mpUID, jwt) {
		return {
			type: actionTypes.MATCHING_PAIRS_SCREENSHOT_INITIALIZE_ROUTE,
			mpUID,
			jwt,
		}
	},
	updateMatchingPairsCreationTool(mpUID, params, search) {
		return {
			type: actionTypes.MATCHING_PAIRS_UPDATE_CREATION_TOOL,
			mpUID,
			params,
			search,
		}
	},
	updateMatchingPairsCreationToolSearch(mpUID, params, search) {
		return {
			type: actionTypes.MATCHING_PAIRS_UPDATE_CREATION_TOOL_SEARCH,
			mpUID,
			params,
			search,
		}
	},
	initializePollScreenshot(pollUID, jwt) {
		return {
			type: actionTypes.POLL_SCREENSHOT_INITIALIZE_ROUTE,
			pollUID,
			jwt,
		}
	},
	initializeQuizScreenshot(quizUID, jwt) {
		return {
			type: actionTypes.QUIZ_SCREENSHOT_INITIALIZE_ROUTE,
			quizUID,
			jwt,
		}
	},
	initializeOeqScreenshot(oeqUID, jwt) {
		return {
			type: actionTypes.OEQ_SCREENSHOT_INITIALIZE_ROUTE,
			oeqUID,
			jwt,
		}
	},
	initializeCreationToolPoll(pollUID) {
		return {
			type: actionTypes.POLL_INITIALIZE_CREATION_TOOL,
			pollUID,
		}
	},
	finalizeCreationToolPoll() {
		return {
			type: actionTypes.POLL_FINALIZE_CREATION_TOOL,
		}
	},
	initializeCreationToolDrawIt(drawItUID, params, search) {
		return {
			type: actionTypes.DRAW_IT_INITIALIZE_CREATION_TOOL,
			drawItUID,
			params,
			search,
		}
	},
	updateCreationToolDrawItSearch(drawItUID, params, search) {
		return {
			type: actionTypes.DRAW_IT_UPDATE_CREATION_TOOL_SEARCH,
			drawItUID,
			params,
			search,
		}
	},
	updateCreationToolDrawIt(drawItUID, params, search) {
		return {
			type: actionTypes.DRAW_IT_UPDATE_CREATION_TOOL,
			drawItUID,
			params,
			search,
		}
	},
	finalizeCreationToolDrawIt() {
		return {
			type: actionTypes.DRAW_IT_FINALIZE_CREATION_TOOL,
		}
	},
	initializeMyLibrary(
		folderUID,
		query,
		orderField,
		lti,
		trigger,
		newQuickLaunchActivity,
		navigationMenuView
	) {
		return {
			type: actionTypes.MY_LIBRARY_INITIALIZE,
			folderUID,
			query,
			orderField,
			lti,
			trigger,
			newQuickLaunchActivity,
			navigationMenuView,
		}
	},

	finalizeMyLibrary() {
		return {
			type: actionTypes.MY_LIBRARY_FINALIZE,
		}
	},

	updateMyLibraryRoute(folderUID) {
		return {
			type: actionTypes.MY_LIBRARY_ROUTE_UPDATE,
			folderUID,
		}
	},

	// @TODO: Remove updateMyLibraryRouteFlags and the action type
	// when the feature flag NOTIFICATION_PREFERENCES is removed
	updateMyLibraryRouteFlags(navigationMenuView) {
		return {
			type: actionTypes.MY_LIBRARY_ROUTE_FLAGS_UPDATE,
			navigationMenuView,
		}
	},

	initializeCreationToolDesmos(desmosUID) {
		return {
			type: actionTypes.DESMOS_INITIALIZE_CREATION_TOOL,
			desmosUID,
		}
	},

	finalizeCreationToolDesmos() {
		return {
			type: actionTypes.DESMOS_FINALIZE_CREATION_TOOL,
		}
	},

	initializeCreationToolInteractiveVideo(uid, jwt, search = {}, params = {}) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL,
			uid,
			jwt,
			search,
			params,
		}
	},

	updateCreationToolInteractiveVideo(search) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_UPDATE_CREATION_TOOL,
			search,
		}
	},

	finalizeCreationToolInteractiveVideo() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_FINALIZE_CREATION_TOOL,
		}
	},

	initializeVideoPickerRoute(uid, jwt, search, params) {
		return {
			type: actionTypes.VIDEO_INITIALIZE_PICKER_ROUTE,
			uid,
			jwt,
			search,
			params,
		}
	},

	initializeVideoEditRoute(uid, jwt, params) {
		return {
			type: actionTypes.VIDEO_INITIALIZE_EDIT_ROUTE,
			uid,
			jwt,
			params,
		}
	},

	updateVideoPickerRoute(search) {
		return {
			type: actionTypes.VIDEO_UPDATE_PICKER_ROUTE,
			search,
		}
	},

	initializeSelectInteractiveVideo(uid, jwt) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_INITIALIZE_SELECT_ROUTE,
			uid,
			jwt,
		}
	},

	initializeInteractiveVideoScreenshot(mediaUid, jwt) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_INITIALIZE_SCREENSHOT_ROUTE,
			uid: mediaUid,
			jwt,
		}
	},

	initializeStandaloneCreationToolDesmos(desmosUID) {
		return {
			type: actionTypes.DESMOS_INITIALIZE_CREATION_TOOL_STANDALONE,
			desmosUID,
		}
	},

	finalizeStandaloneCreationToolDesmos() {
		return {
			type: actionTypes.DESMOS_FINALIZE_CREATION_TOOL_STANDALONE,
		}
	},

	initializeStoreBaseRoute(originRouteType) {
		return {
			type: actionTypes.STORE_BASE_ROUTE_INITIALIZE,
			originRouteType,
		}
	},

	initializeStoreLandingRoute() {
		return {
			type: actionTypes.STORE_LANDING_INITIALIZE,
		}
	},

	initializeStoreSearchRoute(params) {
		return {
			type: actionTypes.STORE_SEARCH_ROUTE_INITIALIZE,
			params,
			query: params.q,
			filters: params.filters,
		}
	},

	updateStoreSearchRoute(params) {
		return {
			type: actionTypes.STORE_SEARCH_ROUTE_UPDATE,
			params,
		}
	},

	initializeStoreFolderRoute(folderUID) {
		return {
			type: actionTypes.STORE_FOLDER_INITIALIZE,
			folderUID,
			page: 0,
		}
	},

	initializeStorePreviewRoute(entity_ID, entity_type, fromStrand) {
		return {
			type: actionTypes.STORE_PREVIEW_INITIALIZE,
			entity_ID,
			entity_type,
			fromStrand,
		}
	},

	initializeTeacherPrivateLibraryRoute() {
		return {
			type: actionTypes.TEACHER_PRIVATE_LIBRARY_ROUTE_INITIALIZE,
		}
	},

	initializeStoreSearch(filters) {
		return {
			type: actionTypes.STORE_SEARCH_INITIALIZE,
			filters,
		}
	},

	initializeConnectedStoreSearch(filters) {
		return {
			type: actionTypes.STORE_CONNECTOR_SEARCH_INITIALIZE,
			filters,
		}
	},

	initializeMyLibraryPreviewRoute(id) {
		return {
			type: actionTypes.MY_LIBRARY_PREVIEW_INITIALIZE,
			id,
		}
	},

	exitMyLibraryPreviewRoute() {
		return {
			type: actionTypes.MY_LIBRARY_PREVIEW_EXIT,
		}
	},

	updateMyLibraryPreviewRoute(id) {
		return {
			type: actionTypes.MY_LIBRARY_PREVIEW_UPDATE,
			id,
		}
	},

	initializeCreationToolOEQ(oeqUID, params) {
		return {
			type: actionTypes.OEQ_INITIALIZE_CREATION_TOOL,
			oeqUID,
			params,
		}
	},

	finalizeCreationToolOEQ() {
		return {
			type: actionTypes.OEQ_FINALIZE_CREATION_TOOL,
		}
	},

	initializeStandaloneOEQ(oeqUID) {
		return {
			type: actionTypes.OEQ_INITIALIZE_STANDALONE,
			oeqUID,
		}
	},

	initializeStandaloneDrawIt(drawItUID, params, search) {
		return {
			type: actionTypes.DRAW_IT_INITIALIZE_STANDALONE,
			drawItUID,
			params,
			search,
		}
	},

	initializeStandaloneQuiz(quizUID) {
		return {
			type: actionTypes.QUIZ_INITIALIZE_STANDALONE,
			quizUID,
		}
	},

	initializeStandalonePoll(pollUID) {
		return {
			type: actionTypes.POLL_INITIALIZE_STANDALONE,
			pollUID,
		}
	},

	initializeStandaloneGame(gameUID, params, search) {
		return {
			type: actionTypes.GAME_INITIALIZE_STANDALONE,
			gameUID,
			params,
			search,
		}
	},

	initializeCreationToolGame(gameUID, params, search) {
		return {
			type: actionTypes.GAME_INITIALIZE_CREATION_TOOL,
			gameUID,
			params,
			search,
		}
	},

	updateCreationToolGameSearch(gameUID, params, search) {
		return {
			type: actionTypes.GAME_UPDATE_CREATION_TOOL_SEARCH,
			gameUID,
			params,
			search,
		}
	},

	updateCreationToolGame(gameUID, params, search) {
		return {
			type: actionTypes.GAME_UPDATE_CREATION_TOOL,
			gameUID,
			params,
			search,
		}
	},

	finalizeCreationToolGame() {
		return {
			type: actionTypes.GAME_FINALIZE_CREATION_TOOL,
		}
	},

	initializeGoogleSlides(params) {
		return {
			type: actionTypes.GOOGLE_SLIDES_INITIALIZE,
			params,
		}
	},

	goToMyActivities() {
		return {
			type: actionTypes.ROUTES_GO_TO_MY_ACTIVITIES,
		}
	},

	goToSubPlans() {
		return {
			type: actionTypes.ROUTES_GO_TO_SUB_PLANS,
		}
	},

	goToPublicLibraryAdmin() {
		return {
			type: actionTypes.ROUTES_GO_TO_PUBLIC_LIBRARY_ADMIN,
		}
	},

	initializeSaveGoogleSlidesActivity(params) {
		return {
			type: actionTypes.GOOGLE_SLIDES_INITIALIZE_ACTIVITY_SAVE,
			params,
		}
	},

	initializeCancelGoogleSlidesActivity() {
		return {
			type: actionTypes.GOOGLE_SLIDES_INITIALIZE_ACTIVITY_CANCEL,
		}
	},

	goToMyLibrary() {
		return {
			type: actionTypes.ROUTES_GO_TO_MY_LIBRARY,
		}
	},

	goToCheckout() {
		return {
			type: actionTypes.ROUTES_GO_TO_CHECKOUT,
		}
	},

	goToStore() {
		return {
			type: actionTypes.ROUTES_GO_TO_STORE,
		}
	},

	goToPrivateLibrary(libraryId) {
		return {
			type: actionTypes.ROUTES_GO_TO_PRIVATE_LIBRARY,
			libraryId,
		}
	},

	goToReports() {
		return {
			type: actionTypes.ROUTES_GO_TO_REPORTS,
		}
	},

	gotToTeacherResources() {
		return {
			type: actionTypes.ROUTES_GO_TO_TEACHER_RESOURCES,
		}
	},

	initializeCreationToolFlocabulary(flocabularyUID, jwt) {
		return {
			type: actionTypes.FLOCABULARY_INITIALIZE_CREATION_TOOL,
			flocabularyUID,
			jwt,
		}
	},

	finalizeCreationToolFlocabulary() {
		return {
			type: actionTypes.FLOCABULARY_FINALIZE_CREATION_TOOL,
		}
	},

	initializeSessionFlocabulary(flocabularyUID, jwt) {
		return {
			type: actionTypes.FLOCABULARY_INITIALIZE_SESSION,
			flocabularyUID,
			jwt,
		}
	},

	initializeFlocabularyScreenshot(flocabularyUID, jwt) {
		return {
			type: actionTypes.FLOCABULARY_SCREENSHOT_INITIALIZE_ROUTE,
			flocabularyUID,
			jwt,
		}
	},

	initializeStandaloneCreationToolFlocabulary(flocabularyUID, jwt) {
		return {
			type: actionTypes.FLOCABULARY_INITIALIZE_CREATION_TOOL_STANDALONE,
			flocabularyUID,
			jwt,
		}
	},

	finalizeStandaloneCreationToolFlocabulary() {
		return {
			type: actionTypes.FLOCABULARY_FINALIZE_CREATION_TOOL_STANDALONE,
		}
	},

	initializeStoreLockedContentRoute() {
		return {
			type: actionTypes.STORE_LOCKED_CONTENT_INITIALIZE_ROUTE,
		}
	},

	finalizeStoreLockedContentRoute() {
		return {
			type: actionTypes.STORE_LOCKED_CONTENT_FINALIZE_ROUTE,
		}
	},

	initializeMatchingPairsStandalone(mpUID, params, search) {
		return {
			type: actionTypes.MATCHING_PAIRS_INITIALIZE_STANDALONE,
			mpUID,
			params,
			search,
		}
	},

	initializeOnboardingActivityCreate() {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_CREATE_INITIALIZE,
		}
	},

	initializeOnboardingActivityExplainer() {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_EXPLAINER_INITIALIZE,
		}
	},

	initializeOnboardingActivityDemo() {
		return {
			type: actionTypes.ONBOARDING_ACTIVITY_DEMO_INITIALIZE,
		}
	},

	initializeGoogleSlidesConfirmView() {
		return {
			type: actionTypes.GOOGLE_SLIDES_CONFIRM_VIEW_INITIALIZE,
		}
	},

	initializeGoogleSlidesLearnMoreView() {
		return {
			type: actionTypes.GOOGLE_SLIDES_LEARN_MORE_VIEW_INITIALIZE,
		}
	},

	initializeQuickLaunchOEQCreationTool(oeqUID, params) {
		return {
			type: actionTypes.QUICK_LAUNCH_OEQ_INITIALIZE_CREATION_TOOL,
			oeqUID,
			params,
		}
	},

	finalizeQuickLaunchOEQCreationTool() {
		return {
			type: actionTypes.QUICK_LAUNCH_OEQ_FINALIZE_CREATION_TOOL,
		}
	},

	initializeSessionInteractiveVideo(uid, jwt) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SESSION_INITIALIZE,
			uid,
			jwt,
		}
	},

	finalizeSessionInteractiveVideo() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_SESSION_FINALIZE,
		}
	},

	initializeInteractiveVideoPreview(uid, jwt) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PREVIEW_INITIALIZE,
			uid,
			jwt,
		}
	},

	finalizeInteractiveVideoPreview() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_PREVIEW_FINALIZE,
		}
	},

	goToAdminDashboardPanel() {
		return {
			type: actionTypes.ADMIN_DASHBOARD_TOOLTIP_ACCEPTED,
		}
	},

	initializeQuickLaunchTimer() {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_INITIALIZE,
		}
	},

	finalizeQuickLaunchTimer() {
		return {
			type: actionTypes.QUICK_LAUNCH_TIMER_FINALIZE,
		}
	},

	initializeQuickLaunchDrawItCreationTool(drawItUID, params) {
		return {
			type: actionTypes.QUICK_LAUNCH_DRAW_IT_INITIALIZE_CREATION_TOOL,
			drawItUID,
			params,
		}
	},

	finalizeQuickLaunchDrawItCreationTool() {
		return {
			type: actionTypes.QUICK_LAUNCH_DRAW_IT_FINALIZE_CREATION_TOOL,
		}
	},

	initializeCreationToolFlipgrid(flipgridUID, params) {
		return {
			type: actionTypes.FLIPGRID_CREATION_TOOL_INITIALIZE,
			flipgridUID,
			params,
		}
	},

	finalizeCreationToolFlipgrid() {
		return {
			type: actionTypes.FLIPGRID_CREATION_TOOL_FINALIZE,
		}
	},

	initializeStandaloneFlipgrid(flipgridUID, params) {
		return {
			type: actionTypes.FLIPGRID_INITIALIZE_STANDALONE,
			flipgridUID,
			params,
		}
	},

	initializeSSOSuccess(params) {
		return {
			type: actionTypes.SSO_SUCCESS_INITIALIZE,
			params,
		}
	},

	initializeInteractiveVideoOEQCreationTool(
		uid,
		jwt,
		activityUid,
		breakpointUid,
		breakpointActivityUid,
		isEdition,
	) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_INITIALIZE,
			uid,
			jwt,
			activityUid,
			breakpointUid,
			breakpointActivityUid,
			isEdition,
		}
	},

	initializeVideoOEQCreationTool(
		uid,
		jwt,
		activityUid,
		breakpointUid,
		breakpointActivityUid,
		isEdition,
		params,
	) {
		return {
			type: actionTypes.VIDEO_CREATION_OEQ_INITIALIZE,
			uid,
			jwt,
			activityUid,
			breakpointUid,
			breakpointActivityUid,
			isEdition,
			params,
		}
	},

	finalizeInteractiveVideoOEQCreationTool() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_OEQ_FINALIZE,
		}
	},

	initializeSessionFillInTheBlanks(params) {
		return {
			type: actionTypes.FILL_IN_THE_BLANKS_SESSION_INITIALIZE_ROUTE,
			params,
		}
	},

	initializeInteractiveVideoMCQCreationTool(
		uid,
		jwt,
		activityUid,
		breakpointUid,
		breakpointActivityUid,
		isEdition
	) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_INITIALIZE,
			uid,
			jwt,
			activityUid,
			breakpointUid,
			breakpointActivityUid,
			isEdition,
		}
	},

	initializeVideoMCQCreationTool(
		uid,
		jwt,
		activityUid,
		breakpointUid,
		breakpointActivityUid,
		isEdition,
		params,
	) {
		return {
			type: actionTypes.VIDEO_CREATION_MCQ_INITIALIZE,
			uid,
			jwt,
			activityUid,
			breakpointUid,
			breakpointActivityUid,
			isEdition,
			params,
		}
	},

	finalizeInteractiveVideoMCQCreationTool() {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_FINALIZE,
		}
	},

	initializeCreationToolInteractiveVideoEdit(uid, jwt, params = {}) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL_EDIT,
			uid,
			jwt,
			params,
		}
	},

	initializeCreationToolBaseInteractiveVideo(uid, jwt, params = {}) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL_BASE,
			uid,
			jwt,
			params,
		}
	},

	initializeCreationToolBaseVideo(uid, jwt, params = {}) {
		return {
			type: actionTypes.VIDEO_INITIALIZE_CREATION_TOOL_BASE,
			uid,
			jwt,
			params,
		}
	},

	initializeStandaloneVideoPickerRoute(uid, jwt, search, params) {
		return {
			type: actionTypes.VIDEO_STANDALONE_INITIALIZE_PICKER_ROUTE,
			uid,
			jwt,
			search,
			params,
		}
	},

	updateStandaloneVideoPickerRoute(search) {
		return {
			type: actionTypes.VIDEO_STANDALONE_UPDATE_PICKER_ROUTE,
			search,
		}
	},

	initializeStandaloneVideoEditRoute(uid, jwt, params) {
		return {
			type: actionTypes.VIDEO_STANDALONE_INITIALIZE_EDIT_ROUTE,
			uid,
			jwt,
			params,
		}
	},

	initializeStandaloneInteractiveVideo(uid, jwt, role, featureFlags, headers, shouldShowImmersiveReader) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_STANDALONE_INITIALIZE,
			uid,
			jwt,
			role,
			featureFlags,
			headers,
			shouldShowImmersiveReader,
		}
	},

	initializeStandaloneVideo(uid, jwt, params = {}) {
		return {
			type: actionTypes.VIDEO_STANDALONE_INITIALIZE_BASE,
			uid,
			jwt,
			params,
		}
	},

	initializeStandaloneVideoOEQCreationTool(
		uid,
		jwt,
		activityUid,
		breakpointUid,
		breakpointActivityUid,
		isEdition,
		params,
	) {
		return {
			type: actionTypes.VIDEO_STANDALONE_OEQ_INITIALIZE,
			uid,
			jwt,
			activityUid,
			breakpointUid,
			breakpointActivityUid,
			isEdition,
			params,
		}
	},

	finalizeStandaloneVideoOEQCreationTool() {
		return {
			type: actionTypes.VIDEO_STANDALONE_OEQ_FINALIZE,
		}
	},

	initializeStandaloneVideoMCQCreationTool(
		uid,
		jwt,
		activityUid,
		breakpointUid,
		breakpointActivityUid,
		isEdition,
		params,
	) {
		return {
			type: actionTypes.VIDEO_STANDALONE_MCQ_INITIALIZE,
			uid,
			jwt,
			activityUid,
			breakpointUid,
			breakpointActivityUid,
			isEdition,
			params,
		}
	},

	finalizeStandaloneVideoMCQCreationTool() {
		return {
			type: actionTypes.VIDEO_STANDALONE_MCQ_FINALIZE,
		}
	},

	initializeSessionPreviewRoute() {
		return {
			type: actionTypes.SESSION_PREVIEW_INITIALIZE,
		}
	},

	initializeStudentJoinRoute(params) {
		return {
			type: actionTypes.STUDENT_JOIN_INITIALIZE,
			params,
		}
	},

	intializeNewTermsAndConditionsRoute(referer) {
		return {
			type: actionTypes.NEW_TERMS_AND_CONDITIONS_INITIALIZE,
			referer,
		}
	},

	initializeStandaloneWhiteboard(slideId, sessionId) {
		return {
			type: actionTypes.WHITEBOARD_STANDALONE_INITIALIZE,
			slideId,
			sessionId,
		}
	},
}

export default routeActions
